import Typography, { TypographyProps } from '@material-ui/core/Typography';
import { FC, memo } from 'react';
import { InjectedFieldProps, PublicFieldProps, sanitizeFieldRestProps } from 'react-admin';

const Field: FC<FieldProps> = memo(props => {
    const { className, emptyText, value, ...rest } = props;
    return (
        <Typography
            component="span"
            variant="body2"
            className={className}
            {...sanitizeFieldRestProps(rest)}
        >
            {value != null && typeof value !== 'string'
                ? JSON.stringify(value)
                : value || emptyText}
        </Typography>
    );
});

Field.defaultProps = {
    emptyText: "",
    addLabel: true
};

export interface FieldProps
    extends TypographyProps, PublicFieldProps,
    InjectedFieldProps {
    value?: string;
    label?: string;
}

export default Field;